import { KindeUser } from "../models/organisation";
import axiosConfig from "./axiosConfig";

export interface OrganisationUsersResponse {
  users: KindeUser[];
}

const getOrganisationUsers = async (
  authToken: string,
  orgId: string,
  siteId?: string,
  userOrgId?: string
): Promise<OrganisationUsersResponse> => {
  let url = `/organisation/${orgId}/user${siteId ? `?siteId=${siteId}` : ""}`;
  if (userOrgId) {
    url += `${siteId ? "&" : "?"}userOrgId=${userOrgId}`;
  }
  const { data } = await axiosConfig.get(url, {
    headers: {
      Authorization: `Bearer ${authToken}`,
    },
  });
  return data;
};

export default getOrganisationUsers;
